<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Локальный сервер</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-btn
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>
    
    <Server :loading="loading" :config="$store.getters.config.local_server" ref="form"/>
  </div>
</template>

<script>

import Teleport from 'vue2-teleport'
import Server from '../../components/settings/server'


export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {local_server: this.$refs.form.submit()}

        if (new_config.local_server.locale != this.$store.getters.config.local_server.locale) {
          
          await this.$store.dispatch('setLocale', new_config.local_server.locale)
          delete new_config.local_server.locale

          this.$store.dispatch('throwMessage', {
            message_data: this.$t('Изменен язык интерфейса. Кликните на это уведомление для перезагрузки страницы.'),
            message_class: 'success',
            resolver: async () => {
              location.reload()
            }
          })
        }

        
        await this.$store.dispatch('updateConfig', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    Server
  }
}
</script>